import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserSessionService } from '../user-session/user-session.service';
import { SharedViewComponent } from '../../models/shared-view-component';
import { SharedItemsService } from '../shared-items/shared-items.service';
import { EbookFaqComponent } from '../../../e-book/components/ebook-faq/ebook-faq.component';
import { AppNetworkService } from '../app-network-service/app-network.service';
import { AlertControllerService } from '../alert-controller/alert-controller.service';
import { Messages } from '../../Constants/messages';

@Injectable({
  providedIn: 'root'
})
export class AppBootstrapperService {
  private _disconnectedAlertId = 'app_disconnected_alert';
  private viewContainerRef: ViewContainerRef;

  constructor(private _userSessionService: UserSessionService,
    private _sharedItemsService: SharedItemsService,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _networkService: AppNetworkService,
    private _alertCtrl: AlertControllerService) {
    this.initFaq();
    this.watchNetwork();
    this._userSessionService.watchUserCurrentSessionValidity().subscribe();
  }

  private initFaq() {
    let viewComponent = new SharedViewComponent(this._componentFactoryResolver.resolveComponentFactory(EbookFaqComponent), 1);
    this._sharedItemsService.addFaqItem(viewComponent);
  }

  setViewContainer(viewContainerRef)
  {
    this.viewContainerRef = viewContainerRef;
  }

  private watchNetwork() {
    this._networkService.networkStatusChanged().pipe(
      switchMap(connected => {
        if (connected) {
          return of(this._alertCtrl.closeAlert(this._disconnectedAlertId));
        } else {
          return this._alertCtrl.presentBlockingErrorAlert(this._disconnectedAlertId, Messages.NETWORK_DICONNECTED,this.viewContainerRef, Messages.NETWORK_DICONNECTED_title);
        }
      })
    ).subscribe();
  }
}
